import request from '@/utils/request'

export function updateRobotStealtCfg(data) {
  return request({
    url: 'api/v1/robot-steal/update',
    method: 'post',
    data: data
  })
}

export function getRobotStealList(data) {
  return request({
    url: 'api/v1/robot-steal/getList',
    method: 'post',
    data: data
  })
}

export function delRobotSteal(data) {
  return request({
    url: 'api/v1/robot-steal/delete',
    method: 'delete',
    data: data
  })
}
